import React from 'react';
import { Link } from 'react-router-dom';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

const BlogCard = ({ blog }) => {
    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:scale-105">
            <img
                src={blog.mainImage.asset.url}
                alt={blog.mainImage.alt || blog.title}
                className="w-full h-48 object-cover"
            />
            <div className="p-4">
                <Link to={`/${blog.slug.current}`} className="text-xl font-semibold mb-2">{blog.title}</Link>
                <p className="text-gray-600 text-sm mb-2">
                    {formatDate(blog.publishedAt)}
                </p>
                <div className="flex items-center mb-2">
                    <img
                        src={blog.author.image.asset.url}
                        alt={blog.author.name}
                        className="w-8 h-8 rounded-full mr-2"
                    />
                    <span className="text-sm text-gray-700">{blog.author.name}</span>
                </div>
                <Link
                    to={`/${blog.slug.current}`}
                    className="text-blue-600 hover:underline"
                >
                    Read more
                </Link>
            </div>
        </div>
    );
};

export default BlogCard;
